import { combineReducers } from "redux";
import * as general from "./general";

const appReducer = combineReducers({
  identity: general.generalIdentityReducer,
  major: general.generalMajorReducer,
});

export default appReducer;
